import 'magnific-popup'

$(function() {
  $('.js-carouselModal').off('click');
  $('.js-carouselModal').on('click',function(){
    var targetModal = $(this).attr('href');
    if($(this).attr('data-galleryNum')) {
      var galleryNum = $(this).attr('data-galleryNum');
    } else {
      var galleryNum = 0;
    }
    $.magnificPopup.open({
      items: {src: targetModal},
      type: 'inline',
      mainClass: 'p-whiteBackModal',
      closeOnBgClick: false,
      closeBtnInside: true,
      showCloseBtn: true,
      fixedContentPos: true,
      callbacks: {
        open: function(){
          // init
          var $mainStageItem = $(targetModal).find('.js-prodImgCarouselModalMainStage .item');
          var $thumbItem = $(targetModal).find('.js-prodImgCarouselModalThumbList .item');
          $mainStageItem.hide;
          $mainStageItem.eq(galleryNum).addClass('isSelect')
          $thumbItem.eq(galleryNum).addClass('isSelect')
          // thumbnail click
          $('.js-prodImgCarouselModalThumbList .item').on('click',function(){
            if($(this).hasClass('isSelect')) {
              return false;
            } else {
              $(this).parent().prev('.js-prodImgCarouselModalMainStage').find('.item').removeClass('isSelect');
              $(this).closest('.js-prodImgCarouselModalThumbList').find('.item').removeClass('isSelect');
              $(this).addClass('isSelect');
              var index = $(this).index();
              $(this).parent().prev('.js-prodImgCarouselModalMainStage').find('.item').eq(index).addClass('isSelect')
            }
          });
          // next click
          $('.js-carouselModalNextBtn').on('click',function(){
            var allItemNum = $(this).parent().find('.item').length;
            var nowNum = $(this).parent().find('.item.isSelect').index() + 1;
            $mainStageItem.removeClass('isSelect');
            $thumbItem.removeClass('isSelect');
            if(nowNum < allItemNum) {
              $mainStageItem.eq(nowNum).addClass('isSelect');
              $thumbItem.eq(nowNum).addClass('isSelect');
            } else {
              $mainStageItem.eq(0).addClass('isSelect');
              $thumbItem.eq(0).addClass('isSelect');
            }
          });
          // prev click
          $('.js-carouselModalPrevBtn').on('click',function(){
            var allItemNum = $(this).parent().find('.item').length;
            var nowNum = $(this).parent().find('.item.isSelect').index() + 1;
            $mainStageItem.removeClass('isSelect');
            $thumbItem.removeClass('isSelect');
            if(nowNum > 1) {
              nowNum = nowNum - 2;
              $mainStageItem.eq(nowNum).addClass('isSelect');
              $thumbItem.eq(nowNum).addClass('isSelect');
            } else {
              $mainStageItem.eq(allItemNum - 1).addClass('isSelect');
              $thumbItem.eq(allItemNum - 1).addClass('isSelect');
            }
          });

          const scrollpos = $(window).scrollTop()
          $('body').css('overflow','hidden');
          $('body').css('height','100%');
          $('html').css('height','100%');
          $('.l-container').css({
            position: 'fixed',
            overflow: 'hidden',
            width: '100%',
            top: -scrollpos,
          })
          .attr('data-top', scrollpos)
        },
        close: function(){
          var $mainStageItem = $(targetModal).find('.js-prodImgCarouselModalMainStage .item');
          var $thumbItem = $(targetModal).find('.js-prodImgCarouselModalThumbList .item');
          $mainStageItem.removeClass('isSelect');
          $thumbItem.removeClass('isSelect');
          $('.js-prodImgCarouselModalThumbList .item').off('click');
          $('.js-carouselModalNextBtn').off('click');
          $('.js-carouselModalPrevBtn').off('click');

          $('body').css('overflow','auto');
          $('body').css('height','auto');
          $('html').css('height','auto');
          const returnpos = parseInt($('.l-container').attr('data-top'))
          $('.l-container').removeAttr('style')
          $(window).scrollTop(returnpos)
        }
      }
    }, 0);
    return false;
  })

});



